import React, { FC } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'

interface RadioOption {
  value: string
  label: string
}

interface RadioInputProps {
  register: UseFormRegisterReturn
  options: RadioOption[]
  name: string
  layout?: 'horizontal' | 'vertical'
  className?: string
}

export const RadioInput: FC<RadioInputProps> = ({
  register,
  options,
  name,
  layout = 'horizontal',
  className = ''
}) => {
  const containerClass = layout === 'vertical' ? 'block' : 'flex justify-start flex-wrap'

  return (
    <div className={`px-1 ${containerClass} ${className}`}>
      {options.map((option) => (
        <div
          key={option.value}
          className="min-w-[25%] flex justify-start items-start pr-4"
        >
          <input
            id={`${name}-${option.value}`}
            type="radio"
            value={option.value}
            className="cursor-pointer mt-[6px]"
            {...register}
          />
          <label
            htmlFor={`${name}-${option.value}`}
            className="pl-2 cursor-pointer"
          >
            {option.label}
          </label>
        </div>
      ))}
    </div>
  )
}